module.exports = __webpack_public_path__ + "assets/img/yt2.aed86456.jpg";